"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductProvider = exports.useProductContext = exports.PLATFORMS = void 0;
const react_1 = __importStar(require("react"));
var PLATFORMS;
(function (PLATFORMS) {
    PLATFORMS["aws"] = "aws";
    PLATFORMS["azure"] = "azure";
    PLATFORMS["gcp"] = "gcp";
})(PLATFORMS = exports.PLATFORMS || (exports.PLATFORMS = {}));
const INITIAL_CONTEXT_VALUE = {
    platform: null,
    platformName: '',
    isAws: () => false,
    isAzure: () => false,
    isGcp: () => false,
};
const ProductContext = react_1.createContext(INITIAL_CONTEXT_VALUE);
const useProductContext = () => {
    return react_1.useContext(ProductContext);
};
exports.useProductContext = useProductContext;
const ProductProvider = ({ platform, platformName, children }) => {
    if (!platform) {
        throw new Error('ProductContext: you must configured platform!');
    }
    if (!platformName) {
        throw new Error('ProductContext: you must configured platformName!');
    }
    const isAws = react_1.useCallback(() => {
        return platform === PLATFORMS.aws;
    }, [platform]);
    const isAzure = react_1.useCallback(() => {
        return platform === PLATFORMS.azure;
    }, [platform]);
    const isGcp = react_1.useCallback(() => {
        return platform === PLATFORMS.gcp;
    }, [platform]);
    return (react_1.default.createElement(ProductContext.Provider, { value: {
            platform,
            platformName,
            isAws,
            isAzure,
            isGcp,
        } }, children));
};
exports.ProductProvider = ProductProvider;
//# sourceMappingURL=ProductContext.js.map